module.exports = __webpack_public_path__ + "img/publishing.1d2de759.svg";